import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showNavBar: false,
    scrollDirection: null
  },

  mutations: {
    // SET ANY GIVEN FIELD IN THE STATE TO A GIVEN NEW VALUE
    SETVALUE (state, payload) {
      // THIS BLOCK IS FOR SETTING NESTED OBJECT VALUES DYNAMICALLY
      // payload.child is an array containing the roadmap to the field to be set
      // EG; TO SET foo.bar.baz.zed, PAYLOAD.CHILD WILL BE PASSED AS FOLLOWS;
      // payload.child = ['foo', 'bar', 'baz', 'zed']

      if (payload.child) {
        for (let i = 0; i < payload.child.length; i++) {
          if (payload.child.length === 1) {
            state[payload.name][payload.child[i]] = payload.newValue
          } else if (payload.child.length === 2) {
            state[payload.name][payload.child[0]][payload.child[i]] = payload.newValue
          } else if (payload.child.length === 3) {
            state[payload.name][payload.child[0]][payload.child[1]][payload.child[i]] = payload.newValue
          } else if (payload.child.length === 4) {
            state[payload.name][payload.child[0]][payload.child[1]][payload.child[2]][payload.child[i]] = payload.newValue
          } else if (payload.child.length === 5) {
            state[payload.name][payload.child[0]][payload.child[1]][payload.child[2]][payload.child[3]][payload.child[i]] = payload.newValue
          } else if (payload.child.length === 6) {
            state[payload.name][payload.child[0]][payload.child[1]][payload.child[2]][payload.child[3]][payload.child[4]][payload.child[i]] = payload.newValue
          } else if (payload.child.length > 6) {
            alert("nesting depth has exceeded setter's nesting limit @ store.js")
          }
        }
      } else {
        state[payload.name] = payload.newValue
      }
    }
  },

  actions: {
    // HANDLER FOR setValue -- TO SET ANY VALUE IN THE STATE, GIVEN THE VALUE NAME, AND THE NEW VALUE
    setValue (context, value) {
      context.commit('SETVALUE', value)
    }
  },

  getters: {
    getNavBarState (state) { return state.showNavBar },
    getScrollDirection (state) { return state.scrollDirection }
  }
})
